<template>
  <mdb-container>
    <EditUserPromoCodeBanner/>
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";
import EditUserPromoCodeBanner from "@/components/EditUserPromoCodeBanner.vue";

export default {
  name: "AddUserPromoCodeBanner",
  components: {
    mdbContainer,
    EditUserPromoCodeBanner
  },
  data() {
    return {

    };
  }
};
</script>

<style></style>